<footer class="footer flex-wrap flex-center">
  <div class="footer-copyrights caption">Copyrights 2022 <i>my</i>homeIQ</div>
  <div class="footer-links">
    <a class="caption" href="https://myhomeiq.com/privacy-policy/" target="_blank">Privacy Policy</a>
    <a class="caption" href="https://myhomeiq.com/terms-of-use/" target="_blank">Terms &amp; Conditions</a>
  </div>
</footer>
